import Footer from "./footer/Footer";
import HeaderMain from "./header/HeaderMain";

const LayoutMain = (props) => {
  return (
    <div className="flex min-h-screen flex-col">
      <HeaderMain />
      <main className="mx-auto max-w-7xl px-4 py-4 flex-1">
        {props.children}
      </main>
      <Footer />
    </div>
  );
};

export default LayoutMain;
